import React, { useState } from 'react'
import Text from '../../../components/text'
import MenuBar from '../../../components/svg/menuBar'
import {NavLink, useNavigate} from 'react-router-dom'
import Navbar from '../../../components/navbar'
import logoImage from '../images/millennium-logo.png'
import Button from '../../../components/button'
import UseResponsive from '../../../hooks/useResponsive.hook'
import CloseIcon from '../../../components/svg/closeIcon'

const Header = () => {
    const navigate = useNavigate();
    const {
        isTabletOrMobile
    } = UseResponsive();

    const [isMenuOpen, setIsMenuOpen] = useState();
    const handleMenuClick = () => {
        setIsMenuOpen(state => !state);
        if(isTabletOrMobile) {
        } else {
        }
    }
    const hasToken = () => {
        const token = sessionStorage.getItem('token')
        return token ? true : false
    }
    const handleLogoClick = ()=>{
        if(hasToken) {
            navigate('/vehicle')
        } else {
            window.open(
                'https://www.millenniumgarages.com/',
                '_blank'
            );
        }

    }
    return (
        <header className="header-wrapper">
            <div className="container">
                <div className="header-main-wrap">
                    <div className="header-left">
                        <div className="logo">
                                <div onClick={handleLogoClick}>
                                    <img src={logoImage} alt="Millennium Garages"/>
                                </div>
                        </div>
                        <Text className="ml-4 h-title" type="H3" text="Flex Daily Account Management"/>
                    </div>
                    <div className="header-right">
                        <Navbar isMenuOpen={isTabletOrMobile ? isMenuOpen : !isMenuOpen} />
                        {isTabletOrMobile && (
                            <Button type="button" text={isMenuOpen ? <CloseIcon /> : <MenuBar />} onClick={handleMenuClick} />
                        )}
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header